"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceEditModalButton = InvoiceEditModalButton;
exports.InvoiceAddNewModalButton = InvoiceAddNewModalButton;
exports.CopyButton = CopyButton;
exports.ChangeStatusButton = ChangeStatusButton;
exports.InvoiceIssueModalButton = InvoiceIssueModalButton;
exports.InvoiceSetAsSentModalButton = InvoiceSetAsSentModalButton;
exports.ActionButton = ActionButton;
const react_1 = __importDefault(require("react"));
const InvoiceSeriesModal_1 = require("./InvoiceSeriesModal");
const GeneralModalButtons_1 = require("../../../View/Modals/GeneralModalButtons");
const InvoiceModalBody_1 = require("./InvoiceModalBody");
const InvoiceValidationSchema_1 = require("./InvoiceValidationSchema");
const InvoiceDetails_1 = require("../InvoiceDetails/InvoiceDetails");
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const InvoiceIssueModalBody_1 = require("./InvoiceIssueModalBody");
const InvoiceSetAsSentModalBody_1 = require("./InvoiceSetAsSentModalBody");
const InvoicesController_1 = require("../InvoicesController");
/** przycisk i modal edycji Invoice */
function InvoiceEditModalButton({ modalProps: { onEdit, initialData, shouldRetrieveDataBeforeEdit, repository }, buttonProps, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: InvoiceModalBody_1.InvoiceModalBody,
            modalTitle: "Edycja faktury",
            repository: repository,
            initialData: initialData,
            makeValidationSchema: InvoiceValidationSchema_1.makeInvoiceValidationSchema,
            shouldRetrieveDataBeforeEdit,
            // InvoiceModalBody używa InlineCreateDrawer — modal musi puścić focus do panelu
            enforceFocus: false,
        }, buttonProps: {
            ...buttonProps,
            buttonVariant: "outline-success",
        } }));
}
function InvoiceAddNewModalButton({ modalProps: { onAddNew, contextData }, }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: InvoiceModalBody_1.InvoiceModalBody,
            modalTitle: "Rejestruj fakturę",
            repository: InvoicesController_1.invoicesRepository,
            makeValidationSchema: InvoiceValidationSchema_1.makeInvoiceValidationSchema,
            contextData,
            // InvoiceModalBody używa InlineCreateDrawer — modal musi puścić focus do panelu
            enforceFocus: false,
        }, buttonProps: {
            buttonCaption: "Rejestruj fakturę",
            buttonVariant: "outline-success",
        } }));
}
function CopyButton({ onError, invoice: passedInvoice, }) {
    const [requestPending, setRequestPending] = react_1.default.useState(false);
    // Spróbuj uzyskać fakturę z kontekstu, ale nie rzucaj błędem jeśli nie jest dostępna
    let contextInvoice = null;
    try {
        const invoiceContext = (0, InvoiceDetails_1.useInvoice)();
        contextInvoice = invoiceContext.invoice;
    }
    catch {
        // Hook nie jest dostępny w tym kontekście
    }
    const invoice = passedInvoice || contextInvoice;
    if (!invoice) {
        console.error("CopyButton: Brak faktury do skopiowania");
        return null;
    }
    async function handleClick() {
        try {
            setRequestPending(true);
            // Usuń pola KSeF przed kopiowaniem
            const invoiceToCopy = {
                ...invoice,
                ksefNumber: null,
                ksefStatus: null,
                ksefSessionId: null,
                ksefUpo: null,
                originalKsefNumber: null,
                correctedInvoiceId: null,
                correctionReason: null,
            };
            await InvoicesController_1.invoicesRepository.copyItem(invoiceToCopy);
            setRequestPending(false);
        }
        catch (error) {
            if (error instanceof Error) {
                onError(error);
            }
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Button, { key: "Kopiuj", variant: "outline-secondary", size: "sm", onClick: handleClick },
            react_1.default.createElement("span", { className: "d-inline-flex align-items-center" },
                "Kopiuj",
                requestPending && (react_1.default.createElement(react_bootstrap_1.Spinner, { as: "span", animation: "border", size: "sm", role: "status", "aria-hidden": "true", className: "ms-2" })))),
        " ",
        react_1.default.createElement(InvoiceSeriesModal_1.InvoiceSeriesButton, { invoice: invoice })));
}
function ChangeStatusButton({ specialActionRoute, newStatus, }) {
    const { invoice, setInvoice } = (0, InvoiceDetails_1.useInvoice)();
    async function handleChangeStatus() {
        const editedInvoice = await InvoicesController_1.invoicesRepository.editItem(invoice, specialActionRoute);
        setInvoice(editedInvoice);
    }
    return (react_1.default.createElement(react_bootstrap_1.Button, { key: `Ustaw jako ${newStatus}`, variant: "primary", size: "sm", onClick: handleChangeStatus }, `Ustaw jako ${newStatus}`));
}
function InvoiceIssueModalButton() {
    const { invoice, setInvoice } = (0, InvoiceDetails_1.useInvoice)();
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: setInvoice,
            specialActionRoute: "issueInvoice",
            ModalBodyComponent: InvoiceIssueModalBody_1.InvoiceIssueModalBody,
            modalTitle: "Wystaw fakturę",
            repository: InvoicesController_1.invoicesRepository,
            initialData: invoice,
            makeValidationSchema: InvoiceValidationSchema_1.makeInvoiceIssueValidationSchema,
        }, buttonProps: {
            buttonCaption: "Wystaw fakturę",
            buttonVariant: "primary",
        } }));
}
function InvoiceSetAsSentModalButton() {
    const { invoice, setInvoice } = (0, InvoiceDetails_1.useInvoice)();
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: setInvoice,
            specialActionRoute: "setAsSentInvoice",
            ModalBodyComponent: InvoiceSetAsSentModalBody_1.InvoiceSetAsSentModalBody,
            modalTitle: "Nadaj datę wystawienia",
            repository: InvoicesController_1.invoicesRepository,
            initialData: invoice,
            makeValidationSchema: InvoiceValidationSchema_1.makeInvoiceSetAsSentValidationSchema,
        }, buttonProps: {
            buttonCaption: "Nadaj datę wystawienia",
            buttonVariant: "primary",
        } }));
}
function ActionButton() {
    const { invoice, setInvoice } = (0, InvoiceDetails_1.useInvoice)();
    switch (invoice.status) {
        case MainSetupReact_1.default.InvoiceStatuses.FOR_LATER:
            return (react_1.default.createElement(ChangeStatusButton, { specialActionRoute: "setAsToMakeInvoice", newStatus: MainSetupReact_1.default.InvoiceStatuses.TO_DO }));
        case MainSetupReact_1.default.InvoiceStatuses.TO_DO:
            return react_1.default.createElement(InvoiceIssueModalButton, null);
        case MainSetupReact_1.default.InvoiceStatuses.DONE:
            // Zachowanie dla starych faktur w statusie "Zrobiona"
            return react_1.default.createElement(InvoiceSetAsSentModalButton, null);
        case MainSetupReact_1.default.InvoiceStatuses.SENT:
        case MainSetupReact_1.default.InvoiceStatuses.SENT_TO_KSEF:
            return (react_1.default.createElement(ChangeStatusButton, { specialActionRoute: "setAsPaidInvoice", newStatus: MainSetupReact_1.default.InvoiceStatuses.PAID }));
        case MainSetupReact_1.default.InvoiceStatuses.PAID:
        case MainSetupReact_1.default.InvoiceStatuses.TO_CORRECT:
        case MainSetupReact_1.default.InvoiceStatuses.WITHDRAWN:
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
